/* eslint-disable indent */

import { useTranslation } from "next-i18next";
import Image from "next/dist/client/image";
import styles from "./Deadline.module.scss";
import Button from "@cs/components/olympiad/Button";
import { useRouter } from "next/router";
import { changeRouteKeepParams } from "util/changeRouteKeepParams";
import { getMonth } from "@cs/lib/olympiad/getDeadlineMonth";

const Deadline = () => {
  const { t } = useTranslation(["olympiad", "common"])
  const router = useRouter()

  return (
    <>
      <section className={styles.container}>
        <figure className={styles.figure}>
          <Image
            src="/img/_common/orange_wave.png"
            alt={t("deadline")}
            layout='responsive'
            width={1446}
            height={200}
          />
        </figure>
        <article className={styles.content}>
          <figure className={styles.figure}>
            <Image
              src="/img/olympiad/trophy_earthly.png"
              alt={t("deadline")}
              width={410}
              height={725}
              layout='responsive'
            />
          </figure>
          <section className={styles.text}>
            <header>
              <h3 className={`${styles.h3} ${styles.underlined}`}>
                {
                  t("deadline", {
                    month:
                    t(
                      `months.${getMonth()}.long`,
                      {ns:"common"}
                    )
                  })
                }
              </h3>
              <h2  className={styles.h2}>
                {
                  t(`deadline-date.${getMonth()}`)
                }
              </h2>
            </header>
            <Button
              className={styles.button}
              onClick={() =>
                window.open(
                  changeRouteKeepParams(`
                  https://olympiad.${process.env.NEXT_PUBLIC_DOMAIN}${
                    router.locale == "en" ? "" : "/" + router.locale
                  }/signup`),
                  "_blank",
                  )
                }
            >
              {t("register-now")}
            </Button>
            <footer className={styles.dates}>
              <div>
                <h4 className={styles.h4}>
                  {t("last-qualifier.title")}
                </h4>
                <h3 className={styles.h3}>
                  {t("last-qualifier.date")}
                </h3>
              </div>
              <div>
                <h4 className={styles.h4}>
                  {t("olympiad-ceremony.title")}
                </h4>
                <h3 className={styles.h3}>
                  {t("olympiad-ceremony.date")}
                </h3>
              </div>
            </footer>
          </section>
        </article>
      </section>
    </>
  )
}

export default Deadline;